//
export default [
	{
		name: 'name',
		type: 'text-field',
		props: {
			label: 'Nombre',
		},
	},
	{
		name: 'name_exact',
		type: 'text-field',
		props: {
			label: 'Nombre exacto',
		},
	},
]